import { FunctionComponent } from 'react';
import {
    ConnectedProps,
    connectTicketsSelectionList,
} from './connectTicketsSelectionList';
import {
    TicketsSelectionList,
    TicketsSelectionListProps,
} from './TicketsSelectionList';

export type ConnectedTicketsSelectionListProps = Omit<
    TicketsSelectionListProps,
    keyof ConnectedProps
>;

export default connectTicketsSelectionList(
    TicketsSelectionList,
) as FunctionComponent<ConnectedTicketsSelectionListProps>;
